module.exports = __webpack_public_path__ + "4aa5ab1e1c96780502c85ab8ccf0de8c.mp4";